import { Stack } from "@mui/material";


const CITFormGroup = ({ children, ...boxProps }) => {

    return (
        <Stack  spacing= {'24px'} mt={ boxProps.mt ?? '24px'} width={ boxProps.width ?? 'auto' } justifyContent={'space-between'} alignItems={ boxProps.align ?? "baseline"} direction={{xs:'column', md:boxProps.direction ?? 'row'}} mx={{xs: boxProps.mx ?? '19px', sm: boxProps.mx ?? '60px',md: boxProps.mx ?? '85px'}} >
            {children}
        </Stack>
    )

}

export default CITFormGroup;